import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { BOOK_CALENDAR_ON_SITE, BOOK_CALENDAR_ON_PHONE, BOOK_CALENDAR_BY_ONLINE_VIDEO, BOOK_CALENDAR_ON_SITE_IN_BRANCH, BOOK_CALENDAR_IN_BRANCH_FACE_TO_FACE, BOOK_CALENDAR_IN_BRANCH_VIDEOCONFERENCE, BOOK_CALENDAR_IN_BRANCH_PRIVATE_VIDEO, BOOK_CALENDAR_IN_BRANCH_BY_PHONE_PUBLIC, BOOK_CALENDAR_IN_BRANCH_BY_PHONE_PRIVATE, BOOK_CALENDAR_IN_BRANCH_BY_VIDEO_PRIVATE, BOOK_CALENDAR_IN_BRANCH_BY_VIDEO_PUBLIC, BOOK_CALENDAR_IN_SERVICE_POINT, BOOK_CALENDAR_IN_SERVICE_POINT_BY_PHONE, BOOK_CALENDAR_TYPES, CONSULT_CALENDAR_TYPES, CONSULT_CALENDAR_COMPANY, CONSULT_CALENDAR_USER, CONSULT_CALENDAR_BRANCH, CONSULT_CALENDAR_HUB, CONSULT_CALENDAR_ROOM, CONSULT_CALENDAR_SERVICE_POINT, } from '@/helpers/calendar';
import { SHIFTS_CALENDAR_PARAM } from '@/helpers/consts';
let CalendarMixin = class CalendarMixin extends Vue {
    get isBookCalendarType() {
        // eslint-disable-next-line max-len
        return Boolean(this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) && BOOK_CALENDAR_TYPES.includes(this.$route.meta.getName(this.$route)));
    }
    get isConsultCalendarType() {
        // eslint-disable-next-line max-len
        return Boolean(this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) && CONSULT_CALENDAR_TYPES.includes(this.$route.meta.getName(this.$route)));
    }
    get cellSize() {
        return this.isBookCalendarType ? 90 : 100;
    }
    get isBookCalendarOnPhone() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === BOOK_CALENDAR_ON_PHONE;
    }
    get isBookCalendarOnSite() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === BOOK_CALENDAR_ON_SITE;
    }
    get isBookCalendarOnSiteInBranch() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === BOOK_CALENDAR_ON_SITE_IN_BRANCH;
    }
    get isBookCalendarByOnlineVideo() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === BOOK_CALENDAR_BY_ONLINE_VIDEO;
    }
    get isBookCalendarInBranchFaceToFace() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === BOOK_CALENDAR_IN_BRANCH_FACE_TO_FACE;
    }
    get isBookCalendarBranchPrivateVideo() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === BOOK_CALENDAR_IN_BRANCH_PRIVATE_VIDEO;
    }
    get isBookCalendarInBranchVideoconference() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === BOOK_CALENDAR_IN_BRANCH_VIDEOCONFERENCE;
    }
    get isBookCalendarBranchByPhonePublic() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === BOOK_CALENDAR_IN_BRANCH_BY_PHONE_PUBLIC;
    }
    get isBookCalendarBranchByPhonePrivate() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === BOOK_CALENDAR_IN_BRANCH_BY_PHONE_PRIVATE;
    }
    get isBookCalendarBranchByVideoPublic() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === BOOK_CALENDAR_IN_BRANCH_BY_VIDEO_PUBLIC;
    }
    get isBookCalendarBranchByVideoPrivate() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === BOOK_CALENDAR_IN_BRANCH_BY_VIDEO_PRIVATE;
    }
    get isBookCalendarInServicePoints() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === BOOK_CALENDAR_IN_SERVICE_POINT;
    }
    get isConsultCalendarCompany() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === CONSULT_CALENDAR_COMPANY;
    }
    get isConsultCalendarBranch() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === CONSULT_CALENDAR_BRANCH;
    }
    get isConsultCalendarUser() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === CONSULT_CALENDAR_USER;
    }
    get isConsultCalendarHub() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === CONSULT_CALENDAR_HUB;
    }
    get isConsultCalendarRoom() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === CONSULT_CALENDAR_ROOM;
    }
    get isConsultCalendarServicePoint() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === CONSULT_CALENDAR_SERVICE_POINT;
    }
    get isBookCalendarInServicePointsByPhone() {
        return this.$route.meta && this.$route.meta.getName && this.$route.meta.getName(this.$route) === BOOK_CALENDAR_IN_SERVICE_POINT_BY_PHONE;
    }
    get isConsultCalendarServicePointShifts() {
        return this.isConsultCalendarServicePoint && this.$route.params.param === SHIFTS_CALENDAR_PARAM;
    }
    get isCalendarWithDriveManagement() {
        return this.isBookCalendarOnSite || this.isBookCalendarOnSiteInBranch;
    }
};
CalendarMixin = __decorate([
    Component
], CalendarMixin);
export default CalendarMixin;
;
